import { useEffect, useRef } from 'react'
import { refreshCoordinator, type RefreshResource } from './refreshCoordinator'

/** Data/initial load stay in the feature hook; this subscribes to refresh signals. */
export function useRefreshSignal({ resource, enabled = true, onRefresh }: {
  resource: RefreshResource
  enabled?: boolean
  onRefresh: () => Promise<unknown> | void
}) {
  const callback = useRef(onRefresh)
  callback.current = onRefresh
  useEffect(() => {
    if (!enabled) return
    return refreshCoordinator.subscribe(resource, () => callback.current())
  }, [resource, enabled])
}
